import * as analytic from '@anm/analytic';
import { RouterContext } from '@anm/contexts/RouterContext';
import useWindowWidthCheck from '@anm/hooks/useWindowWidthCheck';
import { SHOW_MOBILE_HEADER_BREAKPOINT } from '@anm/styles/constants';
import dynamic from 'next/dynamic';
import { useContext, MouseEvent } from 'react';
import { useDispatch } from 'react-redux';

import routes from '../../../routes';
import { projectActions } from '../../../store/modules/project';
import { LeftBarLayoutItem, ListElement } from '../../layouts/LeftBarLayout';
import VideoTemplatesSection from '../../templates/VideoTemplatesSection';
import UserSubscription from '../../user/UserSubscription';
import Account, { AccountTab } from '../Account';
import MyStreamsSection, { LiveTab } from '../MyStreamsSection';
import MyVideosSection from '../MyVideosSection';

import { VideoTemplatesWithSideMenuWrapper } from './Wrapper';
import { MY_STREAMS_TAB, MY_UPLOADS_TAB, MY_VIDEOS_TAB, ProjectTabsProps } from './types';

const { Router } = routes;

const refetchOrNavigate = (canRefetch: boolean, refetchRoot: () => void) => {
  analytic.trackMyProjectsClick();

  canRefetch ? refetchRoot() : Router.pushRoute('my-projects');
};

const DynamicUploads = dynamic(() => import('../MyUploadsSection'), { ssr: false });

export const getProjectsTabs = ({
  activeTab,
  currentTab,
  // onTabChange,
  fetchStreams,
  fetchUploads,
  fetchRootFolder,
  canLiveStream = true
}: ProjectTabsProps) => {
  const dispatch = useDispatch();
  const showMobileNavigation = useWindowWidthCheck(SHOW_MOBILE_HEADER_BREAKPOINT);
  const { params } = useContext(RouterContext);
  const isRootFolder = !params?.folderPath;

  const handelProjectsClick = (evt?: MouseEvent<Element>) => {
    // if (semrush.isSemrushIframe()) { TODO WEB-6634 [SEMRUSH] website stuck after subscription tab
    //   evt?.preventDefault();

    //   onTabChange?.(MY_VIDEOS_TAB);
    //   return;
    // }

    if (evt && activeTab === MY_VIDEOS_TAB) {
      const { ctrlKey, metaKey } = evt;
      const isCmdPressed = ctrlKey || metaKey;

      if (!isCmdPressed) {
        evt.preventDefault();

        refetchOrNavigate(isRootFolder, fetchRootFolder);
        dispatch(projectActions.cancelSearchProjects());
      }
      return;
    }

    refetchOrNavigate(!isRootFolder, fetchRootFolder);
  };

  const handleStreamsClick = (evt?: MouseEvent<Element>) => {
    analytic.trackMyStreamsClick();

    // if (semrush.isSemrushIframe()) {
    //   evt?.preventDefault();

    //   fetchStreams();
    //   onTabChange?.(MY_STREAMS_TAB);
    //   return;
    // }

    if (evt && activeTab === MY_STREAMS_TAB) {
      const { ctrlKey, metaKey } = evt;
      const isCmdPressed = ctrlKey || metaKey;

      if (!isCmdPressed) {
        evt.preventDefault();
        fetchStreams();
        currentTab !== 'upcoming' && Router.pushRoute('lives', { tab: 'upcoming' });
      }
    } else Router.pushRoute('lives', { tab: 'upcoming' });
  };

  const handleUploadsClick = (evt?: MouseEvent<Element>) => {
    // if (semrush.isSemrushIframe()) {
    //   evt?.preventDefault();
    //   fetchUploads();
    //   onTabChange?.(MY_UPLOADS_TAB);
    //   return;
    // }

    if (evt && activeTab === MY_UPLOADS_TAB) {
      const { ctrlKey, metaKey } = evt;
      const isCmdPressed = ctrlKey || metaKey;

      if (!isCmdPressed) {
        evt.preventDefault();
        fetchUploads();
      }
      return;
    }

    fetchUploads();
    Router.pushRoute('uploads');
  };

  const handleVideoTemplatesClick = () => {
    showMobileNavigation && showMobileNavigation && Router.pushRoute('video-templates');
  };

  const livesTitle = showMobileNavigation ? 'Streams & recordings' : 'Streams <br>& recordings';

  const list: (LeftBarLayoutItem | undefined | boolean)[] = [
    {
      button: {
        title: 'Projects',
        icon: 'images/icons/folder-nav.svg',
        href: `/videos`,
        onClick: handelProjectsClick
      },
      renderContent: () => <MyVideosSection />
    },
    canLiveStream && {
      button: {
        title: livesTitle,
        icon: 'images/icons/broadcast-nav.svg',
        href: `/lives`,
        onClick: handleStreamsClick
      },
      renderContent: () => <MyStreamsSection currentTab={currentTab as LiveTab} />
    },
    {
      button: {
        title: 'Uploads',
        href: `/uploads`,
        icon: 'images/icons/grey_upload_ic.svg',
        onClick: handleUploadsClick
      },
      renderContent: () => <DynamicUploads />
    },
    {
      button: {
        title: 'Templates',
        icon: 'images/icons/templates-nav.svg',
        href: `/video-templates`,
        onClick: handleVideoTemplatesClick
      },
      renderContent: () => (
        <VideoTemplatesWithSideMenuWrapper>
          <VideoTemplatesSection isNavigation={showMobileNavigation} isFooter={false} />
        </VideoTemplatesWithSideMenuWrapper>
      )
    },
    {
      renderContent: () => <Account currentTab={currentTab as AccountTab} />
    },
    {
      renderContent: () => <UserSubscription title={null} />
    }
  ];

  return list.filter(Boolean) as ListElement[];
};
